<!-- TODO: investigate dependencies on fcp-input, fcp-form-field and fcp-field-error -->
<fcp-form-field width="fluid" [isInvalid]="inputForm.invalid" [compact]="compact">
    <input
        fcpInput
        [placeholder]="placeholder"
        [formControl]="inputForm"
        (keypress)="maskValue(inputForm.value, $event)"
        (blur)="onBlur(inputForm)"
    />
    <span fcpFieldError>{{
        inputForm.errors?.pattern
            ? errorMessages.pattern
            : inputForm.errors?.existingDate
              ? errorMessages.existingDate
              : errorMessages.minDate
    }}</span>
</fcp-form-field>
